<template>
    <UiPage :blok="blok" :airport="blok.AirportEntity" :products="products" :airport-stats="airportStats" />
    <StoryblokComponent
        v-if="globalStore && globalStore.signInModal"
        :global="globalStore.global.content"
        :blok="globalStore.signInModal"
    />
    <StoryblokComponent
        v-if="globalStore && globalStore.resetPasswordModal"
        :global="globalStore.global.content"
        :blok="globalStore.resetPasswordModal"
    />
    <StoryblokComponent
        v-if="globalStore && globalStore.signUpModal"
        :global="globalStore.global.content"
        :blok="globalStore.signUpModal"
    />
</template>

<script setup lang="ts">
import { useGlobalStore } from '@nuxt-monorepo/base/app/store/global';

const config = useRuntimeConfig();

const { blok } = defineProps({ blok: Object, products: Object, airport: Object, airportStats: Object });
const { t } = useI18n();
const siteInfo = computed(() => {
    return {
        site: 'APR',
        parkingBtnText: t('viewRates'),
    };
});

provide('baseInfo', siteInfo);

const initialDestination = await useUpdateAirportByCode(
    config.public,
    normalizeAirportSlug(blok.AirportEntity.slug),
    false
);
provide('initialDestination', initialDestination);

function normalizeAirportSlug(slug: string): string {
    // Storyblok provides the airport slug for port of seattle as 'sez', but the fetchAlgolia API expects 'zea'.
    if (slug === 'sez') return 'zea';
    return slug;
}

await $getSession();

// Constant variable for access to quote store
const globalStore = useGlobalStore();
</script>
